import React, { useContext, useRef, useState } from 'react';
import cloneDeep from 'lodash.clonedeep';
import get from 'lodash.get';
import CheckboxField from "./FormComponents/CheckboxField";
import { FormContext } from "./FormComponents/Form";
import { cutStepDetails } from 'components/Layout/MapView/cutStepDetails';

function getStepForCut(stepsCompleted, productName) {
    if (stepsCompleted === 0) return cutStepDetails.find(s => s.label === 'Digout');
    if (stepsCompleted === 1) return cutStepDetails.find(s => s.label === 'Base');
    if (stepsCompleted === 2) {
        if (productName === 'Concrete') return cutStepDetails.find(s => s.label === 'Concrete');
        return cutStepDetails.find(s => s.label === 'Surface');
    }
    if (stepsCompleted === 3 && productName === 'Asphalt') {
        return cutStepDetails.find(s => s.label === 'Crack Fill');
    }
    return null;
}

function CutStepForm({ fieldName, cut }) {
    const formContext = useContext(FormContext);
    const [isChecked, setIsChecked] = useState(false);

    // cut.product can be:
    //   - a full API object  {id: "5", name: "Asphalt", surface: "Asphalt", ...}
    //   - a user-selected choice {id: "Asphalt"}  (id IS the name)
    //   - a legacy JSON string  '{"id":"Asphalt"}'
    let productName = '';
    if (typeof cut?.product === 'string' && cut.product !== '') {
        const parsed = JSON.parse(cut.product);
        productName = parsed?.name ?? parsed?.id ?? '';
    } else if (cut?.product && typeof cut.product === 'object') {
        productName = cut.product.name ?? cut.product.id ?? '';
    }

    // Capture the initial step count so checking the box doesn't cascade
    const initialStepsCompleted = useRef(cut?.steps?.length || 0);
    const currentStep = getStepForCut(initialStepsCompleted.current, productName);

    // Cut is already complete
    if (!currentStep) {
        return <p>All steps completed.</p>;
    }

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const handleChange = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);

        let steps = cloneDeep(get(formContext.values, `${fieldName}.steps`));
        if (checked) {
            steps = [...steps, { label: currentStep.value, completedAt: currentDate }];
        } else {
            steps = steps.filter((item) => item.label !== currentStep.label);
        }
        formContext.inputChangeHandler(`${fieldName}.steps`, steps);
    };

    return (
        <CheckboxField
            name={`${fieldName}.steps.${currentStep.label}`}
            id={`${fieldName}.steps.${currentStep.label}`}
            label={`${currentStep.label} Completed?`}
            checked={isChecked}
            onChange={handleChange}
        />
    );
}

export default CutStepForm;
